

















import { Vue, Component, Prop } from "vue-property-decorator";
import { LeaderItem } from "@/views/leader/interface";
@Component
export default class Item extends Vue {
  @Prop() data!: LeaderItem;
  mounted() {
    console.log(this.data.name);
  }
}
